import Number from './number.js';
export default Number;
